import styles from './Button.module.scss'
import cx from 'classnames'
import React, { MouseEvent } from 'react'

type ButtonProps = {
    fn?: (e: MouseEvent<HTMLButtonElement>) => void
    hierarchy: 'primary' | 'secondary' | 'tertiary' | 'tab'
    disabled?: boolean
    type?: 'submit' | 'button' | 'reset'
    text: React.ReactNode
    classes?: string
    active?: boolean
    style?: React.CSSProperties
}

const Button = ({
    fn,
    hierarchy,
    text,
    classes,
    type = 'button',
    disabled = false,
    style,
}: ButtonProps) => {
    let className

    switch (hierarchy) {
        case 'primary':
            className = cx(
                styles['zr-button'],
                styles['zr-button-primary'],
                classes
            )
            break
        case 'secondary':
            className = cx(
                styles['zr-button'],
                styles['zr-button-secondary'],
                classes
            )
            break
        case 'tertiary':
            className = cx(
                styles['zr-button'],
                styles['zr-button-tertiary'],
                classes
            )
            break
        case 'tab':
            className = cx(
                styles['zr-button'],
                styles['zr-button-tab'],
                classes
            )
            break
        default:
            className = cx(
                styles['zr-button'],
                styles['zr-button-secondary'],
                classes
            )
            break
    }

    const onClickHandler = (e: MouseEvent<HTMLButtonElement>) => {
        if (e && fn !== undefined && !disabled) fn(e)
        ;(e.target as HTMLButtonElement).blur()
    }

    return (
        <button
            type={type}
            style={style}
            className={className}
            disabled={disabled}
            onClick={(e) => onClickHandler(e)}
        >
            {text}
        </button>
    )
}

export default Button
